export const domain = '/facturation';
export const product = '/regie';

const baseUrl = `/api${domain}${product}`;

export default baseUrl;
